import React from 'react'

const ClimaCard = ({ data }) => {
    // Conversión de fecha
    const dateSplit = data.date.split("-")
    const date = new Date(dateSplit[0], (dateSplit[1] - 1), dateSplit[2])
    
    // Array para simplificar el switch
    const diasSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]
    const day = diasSemana[date.getDay()]

    return (
        <div 
            className="d-flex flex-column card-clima px-2 justify-items-center align-items-center"
            style={{ flexShrink: 0 }} /* Evita que la tarjeta se achique al deslizar */
        >
            <p className="m-0 greenblue bold">{day}</p>
            <img 
                style={{ objectFit: "contain" }} 
                className="px-2 icon-clima" 
                src={'https://v5i.tutiempo.net/wi/04/50/' + data.icon + '.png'} 
                alt={data.text} 
            />
            {/* Cambiado style={{ width: "5%" }} por "100%" y ajustado a flex-wrap por si el espacio es reducido */}
            <div style={{ width: "100%" }} className="d-flex justify-content-center flex-wrap">
                <div>  
                    <span className="small">Min:</span>
                    <span className="greenblue bold px-2">
                        {(data.temperature_min - 2).toFixed(0)}º
                    </span>
                </div>
                <div>
                    <span className="small">Max:</span>
                    <span className="gold bold px-2">
                        {(data.temperature_max - 2).toFixed(0)}º
                    </span>
                </div>
            </div>
        </div>
    )
}

export default ClimaCard